<form name="formAuthlvl"  style="margin-top:-1.5%;">
    <!-- Device -->
      <div class="container panel panel-default col-md-12" style="padding-left:0%;padding-right:0%;border-color:black;min-height:80vh;background-color: #f4f8f6;">
          <div class="panel panel-heading" style="padding-left:15px;padding-top: 0px;padding-bottom: 0px; background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.4%; color: white;">Add Authorization Levels</div>
          <div class="panel-body">
              <div class="activity-box" *ngIf="dataLoader" ><div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load"/></div></div>
    <!-- search -->
    <div class="form-group row" style="margin-top:-1.5%;">
        <div id="divAuthlvlDetailsCommon" class="col-sm-12" style="margin-top:1%;">
                          <div class="col-sm-3 formdivcaptions ">
                            <label for="drpCountry"> Country<span _ngcontent-mfc-c156="" style="color: red;margin-left: 3px;">*</span> </label>
                            <select class="form-control form-control-sm col-sm-4" [disabled]="dynamicVariable" id="drpCountry" name="drpCountry">
                                    <option value = "India">India</option>
                                </select>
                          </div>
                          <div class="col-sm-3 formdivcaptions ">
                            <label> Facility</label>
                            <ng-multiselect-dropdown  placeholder ="Select" name="FacilityList"  [settings]="dropDownSettings" [data]="MultiSelectCountriesTeams" [(ngModel)]="SelectedFacility"   
                            (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelect)="onItemDeSelect($event)" (onDeSelectAll)="onUnSelectAll($event)"></ng-multiselect-dropdown>
                        </div> 
                          <div class="col-sm-3 formdivcaptions ">
                              <label> Location</label>
                              <ng-multiselect-dropdown  placeholder ="Select" name="LocationList" [settings]="dropDownSettings" [data]="MultiSelectLocationList" [(ngModel)]="SelectedLocation" ></ng-multiselect-dropdown>
                          </div>
                             
                          <div class="col-sm-3 formdivcaptions ">
                              <label> Authorization Level</label>
                              <ng-multiselect-dropdown placeholder ="Select" name="AuthlevlList" [settings]="dropDownSettings" [data]="AuthlvlList" [(ngModel)]="SelectedAuthlvl" ></ng-multiselect-dropdown>
                              </div>                                   
    </div>
                      <div  class="col-sm-6 formdivcaptions" style="margin-top:1%;width: 90%;">
                          <div align="center" id="divAuthlvlSubmit" class="text-center" >
                              <button type="submit" style="margin-top: 25px;" text-align="center" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span> Search</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <button type="submit"style="margin-top: 25px;" text-align="center" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <button type="submit" style="margin-top: 25px;" text-align="center" id="btnExcelExport" class="btn btn-default btn-group-sm Button1" (click)="ExportToBulkExcel()"><span aria-hidden="true"></span> Export to Excel</button>
                          </div>
                      </div>
    </div>
          </div>
  <!-- Grid values -->
  
          <div id="divAuthlvlDetails" style="display:none;">
              <div style="margin-left: 90px; margin-right: 0px;">
                  <table id="AuthlvlDetails" class="table table-bordered" border="1" style="margin-left:2.7%;width:80%;font-size:13px;">
                      <thead style="color :white;background: #8064A2; background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                          <tr>
                              <th style="display:none">SNo</th>
                              <th style="width:10%;"></th>
                              <th style="text-align: center;width:25%;">Country</th>
                              <th style="text-align: center;width:25%;">Facility</th>
                              <th style="text-align: center;width:25%;">Location</th>
                              <th style="text-align: center;width:25%;">Authorization Level</th>
                          </tr>
                      </thead>
                      <tbody *ngFor="let Authlvl of successfulData.Authlvls">
                          <!-- Diplay values -->
                          <tr *ngIf="Authlvl.SlNo != this.successfulData.selected.SlNo">
                              <td style="display:none;">{{Authlvl.SlNo}}</td>
                              <td>
                                  <img src="assets/img/Edit-icon.png" title="Edit" (click)="EditAuthlvl(Authlvl)" />
                                  <img src="assets/img/Delete.png" title="Delete" (click)="DeleteAuthlvl(Authlvl)" />
                              </td>
                              <td>{{Authlvl.Country}}</td>
                              <td>{{Authlvl.City}}</td>
                              <td>{{Authlvl.Location}}</td>
                              <td>{{Authlvl.AuthorizationLevel}}</td>
                          </tr>
                          <!-- Update values -->
                          <tr *ngIf="Authlvl.SlNo ===  this.successfulData.selected.SlNo">
                              <td>
                                  <img src="assets/img/Add.png" (click)="AuthlvlUpdate(Authlvl)" title="Update" />
                                  <img src="assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />
                              </td>
                              <td style="display:none;">{{successfulData.selected.SlNo}}</td>  
                              <td>
                                  <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                      <span>*</span>
                                  </div>
                                  <select class="form-control" [disabled]="dynamicVariable" [(ngModel)]="successfulData.selected.Country" id="grdCountry" name="grdCountry">
                                    <option value = "India">India</option>
                                </select>
                              </td>
                              <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select id="grdFacility" name="grdFacility" [(ngModel)]="successfulData.selected.City" class="form-control" (change)="GetLocationListDropDown(successfulData.selected.City)">
                                  <option value="">&lt;--Select--&gt;</option>
                                  <option *ngFor="let F of Facilities" [ngValue]="F.City">{{F.City}}</option>
                                </select>
                           </td> 
                              <td>
                                  <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                      <span>*</span>
                                  </div>
                                  <select id="grdLocation" name="grdLocation" [(ngModel)]="successfulData.selected.Location" class="form-control">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let L of LocationList" [ngValue]="L.Location">{{L.Location}}</option>
                                  </select>
                             </td> 
                             <td>
                              <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                  <span>*</span>
                              </div>
                              <input type="text" class="form-control" [(ngModel)]="successfulData.selected.AuthorizationLevel" id="grdAuthlvl" placeholder="Enter AuthorizationLevel " name="grdAuthlvl" (keypress)="validateNumber($event)"/>
                          </td>    
                          </tr>
                      </tbody>
        <!-- Grid Add values -->              
                      <tfoot>
                          <tr>
                              <td>
                                  <button id="btnAddCountries" type="button" class="btn btn-default btn-group-sm Button2" (click)="AuthlvlAdd()">
                                      <span class="fa fa-check-circle" aria-hidden="true">
                                      </span> Add
                                  </button>
                              </td>                  
                              <td>
                                  <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                      <span>*</span>
                                  </div>
                                  <select [(ngModel)]="AuthlvlDetails.Country" id="grdfCountry" name="grdfCountry" aria-label="grdfCountry" class="form-control" [disabled]="dynamicVariable">
                                    <option value = "India">India</option>
                                </select>
                              </td>
                              <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select [(ngModel)] ="AuthlvlDetails.City" id="grdfFacility" name="grdfFacility" aria-label="grdfFacility" class="form-control" (change) = "GetLocationListDropDown(AuthlvlDetails.City)">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let F of Facilities">{{F.City}}</option>
                                </select>
                            </td>
                              <td>
                                  <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                      <span>*</span>
                                  </div>
                                  <select [(ngModel)] ="AuthlvlDetails.Location" id="grdfLocation" name="grdfLocation" aria-label="grdfLocation" class="form-control" >
                                      <option value="">&lt;--Select--&gt;</option>
                                      <option *ngFor="let L of LocationList">{{L.Location}}</option>
                                  </select>
                              </td>
                              <td>
                                  <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                      <span>*</span>
                                  </div>
                                  <input type="text" class="form-control" [(ngModel)]="AuthlvlDetails.AuthorizationLevel" id="grdfAuthlvl" name="grdfAuthlvl" aria-label="grdfAuthlvl" (keypress)="validateNumber($event)"/>
                              </td>      
                          </tr>
                          <tr>
                              <td colspan="11" style="text-align: center;">
                   <!-- pager -->
                                  <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                      <li [ngClass]="{disabled:pager.currentPage === 1}">
                                          <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                          </a>
                                      </li>
                                      <li [ngClass]="{disabled:pager.currentPage === 1}">
                                          <a><i (click)="setPage(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                      </li>
                                      <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                          <a (click)="setPage(page)">{{page}}</a>
                                      </li>
                                      <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                          <a (click)="setPage(pager.startPage + 5)">...</a>
                                      </li>
                                      <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                          <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                      </li>
                                      
                                      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                          <a><i (click)="setPage(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                      </li>
                                      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                          <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                      </li>
                                  </ul>
                              </td>
                          </tr>
                      </tfoot>
                  </table>  
              </div>
          </div>
          <div id="AlertForAccess" style="display:none;">
              <div class="row" style="padding-top:-20%">
                  <div class="col-sm-12" style="margin-left:5%;">
                      <h4 style="color:red;">
                          Access Not Available.Please refer User Guidelines section for any access or tool issue.
                      </h4>
                  </div>
              </div>
          </div>
      </div>
  </form>
